import { StyleSheet } from 'react-native';

import { isBigScreen } from '../../media-query';

export default StyleSheet.create({
  container: isBigScreen()
    ? {
        alignItems: 'center',
        width: '100%',
        flexDirection: 'row',
        justifyContent: 'flex-start',
      }
    : {
        alignItems: 'center',
      },
  buttonText: {
    fontWeight: '400',
    fontSize: 20,
    lineHeight: 22,
  },
  cancelButtonContainer: isBigScreen()
    ? {
        marginLeft: 16,
      }
    : {
        marginTop: 24,
      },
});
